import roundDown from './roundDown';

/**
 * @typedef {import('react-advanced-cropper').Coordinates} Coordinates
 */

/**
 * Transforms a coordinates object into a Crop object
 *
 * @param {Coordinates} coordinates The coordinates object
 * @param {number}      width       The width of the image
 * @param {number}      height      The height of the image
 *
 * @return {Crop | undefined}             The crop object
 */
export const transformCoordinatesIntoCrop = (coordinates, width, height) => {
  if (!coordinates) {
    return undefined;
  }

  const result = {
    x: roundDown(coordinates.left / width),
    y: roundDown(coordinates.top / height),
    width: roundDown(coordinates.width / width),
    height: roundDown(coordinates.height / height),
  };

  return result;
};

/**
 * Transforms a crop object into a coordinates object
 *
 * @param {Crop}   crop   The crop object
 * @param {number} width  The width of the image
 * @param {number} height The height of the image
 *
 * @return {Coordinates | undefined}        The coordinates object
 */
export const transformCropIntoCoordinates = (crop, width, height) => {
  if (!crop) {
    return undefined;
  }

  const result = {
    top: crop.y * height,
    left: crop.x * width,
    width: crop.width * width,
    height: crop.height * height,
  };

  return result;
};
